import React, { useCallback, useEffect, useState } from 'react';
import { UseNotificationGroupHookResults } from './useNotificationGroup';
import { FormControlLabel } from '@mui/material';
import MuiCheckbox from '../../mui/MuiCheckbox';
import {
	NotificationGroupInput,
	NotificationGroupInputProps,
} from './NotificationGroupInput';

export type NotificationGroupProps = { disabled?: boolean } & Omit<
UseNotificationGroupHookResults,
'onValidate'
> &
Omit<NotificationGroupInputProps, 'isInEditMode'>;

export const NotificationGroup: React.FC<NotificationGroupProps> = ( {
	disabled,
	...props
} ) => {
	const [ additionalRecipientsEnabled, setAdditionalRecipientsEnabled ] =
		useState( props.value.length > 0 );

	const handleToggle = useCallback(
		( checked: boolean ) => {
			if ( checked ) {
				setAdditionalRecipientsEnabled( checked );
			} else {
				// if we uncheck the value make sure to remove all items from the list
				props.onChange( [] );
				setAdditionalRecipientsEnabled( checked );
			}
		},
		[ props ]
	);

	useEffect( () => {
		setAdditionalRecipientsEnabled( props.value.length > 0 );
	}, [ props.value ] );

	return (
		<>
			<FormControlLabel
				label='Copy a recipient'
				disabled={ disabled }
				control={
					<MuiCheckbox
						data-cy='notification-group-toggle'
						checked={ additionalRecipientsEnabled }
						onChange={ ( _, checked ) => handleToggle( checked ) }
					/>
				}
			/>
			{ additionalRecipientsEnabled ? (
				<NotificationGroupInput
					isInEditMode={ true }
					labelIsForScreenReadersOnly
					disabled={ disabled }
					{ ...props }
				/>
			) : null }
		</>
	);
};
